import React from 'react';
import {Box, BoxProps} from 'components/ui/chakra';

interface SurfaceCardProps extends BoxProps {
	children: React.ReactNode;
	muted?: boolean;
}

const SurfaceCard = ({children, muted = false, ...rest}: SurfaceCardProps) => (
	<Box
		layerStyle={muted ? 'surfaceMuted' : 'surface'}
		overflow='hidden'
		position='relative'
		_before={{
			content: '""',
			position: 'absolute',
			inset: 0,
			pointerEvents: 'none',
			opacity: muted ? 0.04 : 0.06,
			backgroundImage: 'radial-gradient(rgba(79, 74, 68, 0.22) 0.6px, transparent 0.6px)',
			backgroundSize: '16px 16px',
		}}
		{...rest}
	>
		<Box position='relative' zIndex={1}>
			{children}
		</Box>
	</Box>
);

export default SurfaceCard;
